import { Box, Typography } from "@mui/material";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { NOT_FOUND_ICON_BOX_SX, NOT_FOUND_ICON_PROPS } from "./notFound.constants";

const TITLE_SIZES = {
    page: "1.25rem",
    shell: "1.15rem",
};

const CODE_SIZES = {
    page: "7rem",
    shell: "6rem",
};

const RouteNotFoundBody = ({ variant = "shell", description, actions }) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                maxWidth: 420,
                width: "100%",
                px: 3,
            }}
        >
            <Typography
                sx={{
                    fontSize: CODE_SIZES[variant],
                    fontWeight: 800,
                    color: "primary.main",
                    lineHeight: 1,
                    letterSpacing: "-2px",
                }}
            >
                404
            </Typography>

            <Box sx={{ ...NOT_FOUND_ICON_BOX_SX, mt: 1.5, mb: 2.5 }}>
                <ExclamationTriangleIcon style={NOT_FOUND_ICON_PROPS} />
            </Box>

            <Typography sx={{ fontSize: TITLE_SIZES[variant], fontWeight: 700, mb: 1 }}>
                Page not found
            </Typography>

            <Typography variant="body2" sx={{ color: "text.secondary", mb: 3, lineHeight: 1.6 }}>
                {description}
            </Typography>

            {actions}
        </Box>
    );
};

export default RouteNotFoundBody;
